import React from 'react';

import GroupPanels from '../components/GroupPanels';

function WorkPage() {

  return (
    <div>
      <GroupPanels />
    </div>
      
  );
}

export default WorkPage;